import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import store from '@/store';
import httpRequest from '@/utils/request';
import * as crypto from "crypto-js";
var OKEYSERVER = process.env.VUE_APP_OKEY_COMMAND_SERVER;
var sign = "396924b9-4cbd-4f03-b4b6-dbb7f1824e80";
export var machineCommand = {
  power_on: "a8f87abf5",
  power_off: "h8c54952b",
  east_dice: "b140636f2",
  mode_5: "k32e019ba",
  riffle: "y465cd3c7",
  reboot: "b0b02ce4",
  mode_7: "bf229dc7",
  south_dice: "t2c9b868",
  west_dice: "d8ec5edc",
  north_dice: "cf8f5f92",
  test: "o5cbce9de",
  test_loop: "a59b294e",
  update_share: "c8212ed0a",
  update_authorize_time: "d3ddcacc5",
  machine_on: "c9d8265c3",
  machine_off: "e6861486"
};
export var httpRequestMachineCommand = function httpRequestMachineCommand(data) {
  data.userId = localStorage.getItem('userId');
  var md5Org = data.commmand + data.device + (data.msgExtend ? data.msgExtend : "") + data.userId + sign;
  var md5 = crypto.MD5(md5Org).toString(crypto.enc.Hex);
  return httpRequest({
    url: OKEYSERVER + '/okey/publishMessage',
    method: 'post',
    data: data,
    headers: {
      'signature': md5
    }
  });
};